/** JS source for brand + dark canvas. Keep CSS :root in stylesheets/variables.scss in sync. */
export const BRAND = {
  primary: "#7C3AED",
  primaryHover: "#6D28D9",
  primaryRgb: "124, 58, 237",
  secondary: "#EC4899",
  secondaryRgb: "236, 72, 153",
  tertiary: "#06B6D4",
  tertiaryRgb: "6, 182, 212",
};

export const DARK = {
  bgBase: "#05050F",
  bgSurface: "#0D0D1F",
  bgElevated: "#141428",
  /** Modals / centered popups — lighter than canvas so panels never read as black. */
  modalSurface: "#282448",
  /** Popup (Modal) base under its purple glow; keep in sync with the dark modal rule in App.scss. */
  popupSurface: "#11112a",
  bgSubtle: "#1A1A35",
  textMuted: "#6B6B8A",
  textSecondary: "#C4C4D4",
  ink: "#05050F",
};

export const BRAND_THEME = {
  chrome: "#4A4D4E",
  chromeRgb: "74, 77, 78",
};

export const brandAlpha = (alpha) => `rgba(${BRAND.primaryRgb}, ${alpha})`;

export const cssVar = (name, fallback = "") => {
  if (typeof document === "undefined") return fallback;
  return (
    getComputedStyle(document.documentElement).getPropertyValue(name).trim() ||
    fallback
  );
};
